import React from "react";
import styled from "styled-components";
import { HeaderBar } from "@sonder/ui/source/styled/fragments/HeaderBar";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";

const StyledHeaderBar = styled(HeaderBar)`
  > *:not(:last-child) {
    margin-right: 0.6rem;
  }
`;

interface ReportsHeaderProps {
  children: React.ReactNode;
}

export const ReportsHeader = ({ children }: ReportsHeaderProps) => (
  <Scroller>
    <ScrollerContent>
      <StyledHeaderBar>{children}</StyledHeaderBar>
    </ScrollerContent>
  </Scroller>
);
